import { type ChartOptions, type TooltipItem } from "chart.js";

import { type Kpi } from "@features/mmm/components/explore-budgets/client-setting/types";
import { debouncedResize } from "@features/sales-v3/utils/chart";
import { type MetricPrecision } from "@north-beam/nb-common/formatting";

import { todayMarkerAnnotation } from "../spend-chart/plugins/today-marker-annotation";

import { chartTooltip } from "./chart-tooltip";

export function getTrackingChartOptions({
  formatter,
  kpi,
  timezone,
}: {
  formatter: (val: number, precision?: MetricPrecision) => string;
  kpi?: Kpi;
  timezone: string;
}): ChartOptions<"line"> {
  return {
    parsing: false,
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",

      intersect: false,
    },
    // on resize, reload the annotations
    onResize: debouncedResize,
    plugins: {
      title: {
        display: true,
        align: "start",
        font: { size: 18 },
      },
      annotation: {
        annotations: { ...todayMarkerAnnotation(timezone) },
      },
      legend: { display: false },
      tooltip: {
        external: (ctx: any) => chartTooltip(ctx, kpi, formatter),
        mode: "nearest",
        enabled: false,
        itemSort: (a: TooltipItem<"line">, b: TooltipItem<"line">) =>
          b.datasetIndex - a.datasetIndex,
      },
    },
    scales: {
      x: {
        axis: "x",
        grid: {
          drawOnChartArea: true,
          drawBorder: false,
          drawTicks: false,
        },
        ticks: {
          padding: 20,
          maxRotation: 0,
          autoSkip: true,
          font: {
            family: "Commons Pro",
            size: 13,
          },
        },
      },
      y: {
        ticks: {
          padding: 24,
          font: {
            family: "Commons Pro Mono",
            size: 11,
          },
          maxTicksLimit: 6,
          callback: (tickValue) => formatter(Number(tickValue), "approximate"),
        },
        beginAtZero: true,
        display: true,
        position: "left",
        grid: {
          drawTicks: false,
          drawBorder: false,
          drawOnChartArea: true,
        },
      },
    },
  };
}
